import { Observable } from 'rxjs/Observable';
import { EventManager } from 'ng-jhipster';
import { HttpInterceptor, HttpEvent, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';

export class ErrorHandlerInterceptor implements HttpInterceptor {

    constructor(private eventManager: EventManager) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req)
        .do((event: HttpEvent<any>) => {}, (error: any) => {
            if (error instanceof HttpErrorResponse) {
                if (!(error.status === 401 && (error.error === '' ||
                (error.url && error.url.indexOf('/api/account') === 0)))) {
                    this.eventManager.broadcast({ name: 'jYoguiApp.httpError', content: error });
                }

            }
            return Observable.throw(error);
        });
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/blocks/http/interceptor/errorhandler.interceptor.ts